import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    rekapkirimanae(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranrekap/rekapkirimanae${str}`;

                const response = await axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    rekapkirimangroup(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranrekap/rekapkirimangroup${str}`;

                const response = await axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    rekapkirimangroupsales(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranrekap/rekapkirimangroupsales${str}`;

                const response = await axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    rekaprevisiae(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenistgl','tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranrekap/rekaprevisiae${str}`;

                const response = await axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                // const { response } = await axios.get(url);


                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },

    rekaprevisigroup(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenistgl','tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranrekap/rekaprevisigroup${str}`;

                const response = await axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },

    rekapreturae(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenistgl','tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranrekap/rekapreturae${str}`;

                const response = await axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    rekapreturgroup(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['jenistgl','tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/koranrekap/rekapreturgroup${str}`;

                const response = await axios({
                    url,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },

}